import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useCatalog } from '../../contexts/CatalogContext';
import { usePages } from '../../contexts/SiteContext';
import { policyCopy } from '../../data/policies';
import { fill } from '../../utils/copy';
import type { HeroDoor } from '../../core/types/pages';

/**
 * De twee deuren onder de hero: de salon en de webshop, even zwaar, naast elkaar (computer) of
 * onder elkaar (telefoon). Zo ziet een nieuwe bezoeker in één oogopslag dat Beauty Bewust
 * allebei is. Teksten uit Paginateksten › Home › Bovenste deel; een lege titel = geen deur.
 */
export function HeroDoors() {
  const pages = usePages();
  const {
    products
  } = useCatalog();
  const {
    salonDoor,
    shopDoor
  } = pages.home.hero;
  const vars = {
    count: products.length,
    freeShipping: policyCopy.freeShipping
  };
  const doors = [{
    door: salonDoor,
    to: '/behandelingen'
  }, {
    door: shopDoor,
    to: '/webshop'
  }].filter(d => d.door.title);
  if (doors.length === 0) return null;
  return <ul className={`grid border-t border-ink/15 ${doors.length > 1 ? 'sm:grid-cols-2' : ''}`} data-id="element-7327" data-mp="1grwjwcpabrts">
      {doors.map(({
      door,
      to
    }, i) => <li key={to} className={`border-b border-ink/15 sm:border-b-0 ${i > 0 ? 'sm:border-l sm:pl-6' : 'sm:pr-6'}`} data-id="element-7328" data-mp="1crcr1lbqvadg" data-mpi={i}>
          <DoorLink door={door} to={to} body={fill(door.body, vars)} data-id="element-7329" data-mp="12r2du0ppm2ya" />
        </li>)}
    </ul>;
}
function DoorLink({
  door,
  to,
  body
}: {
  door: HeroDoor;
  to: string;
  body: string;
}) {
  return <Link to={to} className="group flex h-full flex-col py-5" data-id="element-7330" data-mp="1vfztrx6g7nnv">
      <span className="type-name text-ink" data-id="element-7331" data-mp="1vgjaxbo9y80u">{fill(door.title)}</span>
      {body && <span className="mt-1.5 block text-[14px] leading-relaxed text-muted" data-id="element-7332" data-mp="1qnq7qs8gf7qv">{body}</span>}
      {door.cta && <span className="mt-auto inline-flex items-center gap-2 pt-3 text-[14px] text-ink" data-id="element-7333" data-mp="1lpewcd2igp6j">
          <span className="underline decoration-ink/25 underline-offset-[5px] transition-[text-decoration-color] duration-150 ease-soft group-hover:decoration-ink" data-id="element-7334" data-mp="2j6wusewph0kc">
            {fill(door.cta)}
          </span>
          <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-soft group-hover:translate-x-1" strokeWidth={1.5} aria-hidden="true" data-id="element-7335" data-mp="chv64j37jpis" />
        </span>}
    </Link>;
}